import type { MotivoNaoEmite } from "@/api/contrato";
import { Pilula } from "@/componentes/PilulaDeSituacao";
import { MOTIVO_DE_NAO_EMITIR } from "./cedente";

/*
 * A situação de um vínculo numa palavra: "não emite", "suspenso" ou nada.
 *
 * Quem decide é o servidor (`emite`, `motivo_nao_emite`), e não a tela: a cadeia é
 * a mesma das pendências do cedente, e uma segunda cópia em TypeScript divergiria
 * dela no primeiro desvio (design D6). O par emitindo não ganha pílula — numa lista
 * de quarenta clínicas, o que precisa saltar é a exceção.
 *
 * O motivo vai no `title`, e não em texto ao lado: a pílula é para varrer a
 * lista; o porquê é para quem parou nela.
 */
export function SituacaoDoPar({
  emite,
  motivo,
}: {
  emite: boolean;
  motivo: MotivoNaoEmite;
}) {
  if (emite) return null;

  if (motivo === "vinculo_suspenso") {
    return (
      <span title={MOTIVO_DE_NAO_EMITIR.vinculo_suspenso}>
        <Pilula matiz="encerrado">suspenso</Pilula>
      </span>
    );
  }

  return (
    <span title={motivo === null ? undefined : MOTIVO_DE_NAO_EMITIR[motivo]}>
      <Pilula matiz="falha">não emite</Pilula>
    </span>
  );
}
